import { plainToInstance } from "class-transformer";
import ModelAgent from "@models/agents/ModelAgent";
import ServiceMainApi from "@/services/v2/service-main-api/ServiceMainApi";

export default class RepositoryAgents {
    public async fetchAgentsAvailableForPurchase(paymentMethod?: 'bank_card' | 'phone'): Promise<ModelAgent[]> {
        const params: Record<string, string> = {};

        if (paymentMethod) {
            params.payment_method = paymentMethod;
        }

        const response = await ServiceMainApi.of().get<{ data: any }>('/api/mobile/client/payments/agents', params);
        return plainToInstance(ModelAgent, response.data, {
            excludeExtraneousValues: true,
        }) as ModelAgent[];
    }
}
